export default __webpack_public_path__ + "assets/teams/default.8ef2b0db231dec9b81c9d8e0d683fbad.svg";